
import { CommonErrorCode, FlowErrorCode } from '~commonInfra/utils/ErrorCodes';
import { Messages } from '~src/codegen/Localize';

export namespace LinkedTaskErrors {
  export function errorMessageFor(errorCode: number) {
    switch(errorCode) {
      case FlowErrorCode.FlowParametersAnyTypeDisabledOnSite:
        return Messages.flowParametersAnyTypeDisabledOnSite();
      case FlowErrorCode.FlowParameterOverrideInvalid:
        return Messages.flowParametersOverrideInvalidError();
      case FlowErrorCode.FlowParameterOverrideMissing:
        return Messages.flowParametersOverrideMissingError();
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return Messages.linkedTasksErrorInsufficientPermissions();
      case CommonErrorCode.LinkedTaskNotFound:
        return Messages.linkedTasksErrorLinkedTaskNotFound();
      case CommonErrorCode.LinkedTaskStepNotFound:
        return Messages.linkedTasksErrorLinkedTaskStepNotFound();
      case CommonErrorCode.LineageForContentNotFound:
        return Messages.linkedTasksErrorLineageForContentNotFound();
      case CommonErrorCode.FlowNotFound:
        return Messages.linkedTasksFlowNotFoundError();
      case CommonErrorCode.UnexpectedErrorOccurred:
      default:
        return Messages.unexpectedError();
    }
  }
}